// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ModelTrackerInput
 */
export interface ModelTrackerInput {
  /**
   *
   */
  revisionId: number;
  /**
   *
   */
  schematisationId: number;
  /**
   *
   */
  inheritFromPreviousModel?: boolean;
  /**
   *
   */
  inheritFromPreviousRevision?: boolean;
}

/**
 * Check if a given object implements the ModelTrackerInput interface.
 */
export function instanceOfModelTrackerInput(value: object): value is ModelTrackerInput {
  if (
    (!("revisionId" in (value as Record<string, any>)) &&
      !("revision_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["revisionId"] === undefined &&
      (value as Record<string, any>)["revision_id"] === undefined)
  )
    return false;
  if (
    (!("schematisationId" in (value as Record<string, any>)) &&
      !("schematisation_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["schematisationId"] === undefined &&
      (value as Record<string, any>)["schematisation_id"] === undefined)
  )
    return false;
  return true;
}

export function ModelTrackerInputFromJSON(json: any): ModelTrackerInput {
  return ModelTrackerInputFromJSONTyped(json, false);
}

export function ModelTrackerInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ModelTrackerInput {
  if (json == null) {
    return json;
  }
  return {
    revisionId: json["revision_id"],
    schematisationId: json["schematisation_id"],
    inheritFromPreviousModel:
      json["inherit_from_previous_model"] == null ? undefined : json["inherit_from_previous_model"],
    inheritFromPreviousRevision:
      json["inherit_from_previous_revision"] == null
        ? undefined
        : json["inherit_from_previous_revision"],
  };
}

export function ModelTrackerInputToJSON(json: any): ModelTrackerInput {
  return ModelTrackerInputToJSONTyped(json, false);
}

export function ModelTrackerInputToJSONTyped(
  value?: ModelTrackerInput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    revision_id: value["revisionId"],
    schematisation_id: value["schematisationId"],
    inherit_from_previous_model: value["inheritFromPreviousModel"],
    inherit_from_previous_revision: value["inheritFromPreviousRevision"],
  };
}
